<template>
    <img :src="getImageUrl(activeImage)" class="overlay-img"/>
</template>

<script>
  export default {
    props: {
      images: {
        type: Array
      },
      activeImage: {
        type: Object,
        required: true
      },
      dropzoneFiles: {
        type: Array
      }
    },
    computed: {
      getImageTitle () {
        return (image) => {
          if (image.title) {
            return image.title
          }
          if (this.dropzoneFiles && image.uuid) {
            let obj = this.dropzoneFiles.find(obj => obj.upload.uuid === image.uuid)
            return obj.name
          }
          return ''
        }
      },
      getImageUrl () {
        return (image) => {
          if (image.url) {
            return image.url
          }
          if (this.dropzoneFiles && image.uuid) {
            let obj = this.dropzoneFiles.find(obj => obj.upload.uuid === image.uuid)
            return obj.dataURL
          }

          return ''
        }
      }
    }
  }
</script>

<style scoped>

</style>
